<script setup>
import { computed } from 'vue';
import InlineInput from 'dashboard/components-next/inline-input/InlineInput.vue';

const props = defineProps({
  modelValue: {
    type: String,
    default: '',
  },
  placeholder: {
    type: String,
    default: '',
  },
  variant: {
    type: String,
    default: 'plain',
  },
});

const emit = defineEmits(['update:modelValue']);

const variantClassMap = {
  plain:
    '!h-auto !min-h-0 !bg-transparent !p-0 !text-[12px] !font-medium !text-n-slate-12',
  plainStrong:
    '!h-auto !min-h-0 !bg-transparent !p-0 !text-[13px] !font-semibold !text-n-slate-12',
  plainSoft:
    '!h-auto !min-h-0 !bg-transparent !p-0 !text-[11px] !text-n-slate-11',
  plainCaption:
    '!h-auto !min-h-0 !bg-transparent !p-0 !text-[10px] !font-normal !text-n-slate-11 placeholder:!text-[10px] placeholder:!font-light placeholder:!text-n-slate-9',
  plainAction:
    '!h-auto !min-h-0 !bg-transparent !p-0 !text-[12px] !font-medium !text-[#128c7e] !outline-none',
  surfaceSm:
    '!h-auto !min-h-0 !rounded-lg !bg-white/85 !px-2 !py-1 !text-[10px] !font-semibold !text-n-slate-10 !outline-none',
  surfaceMd:
    '!h-auto !min-h-0 !rounded-lg !bg-white/90 !px-2 !py-1 !text-[12px] !font-medium !text-n-slate-12 !outline-none',
  surfaceSoft:
    '!mt-1 !h-auto !min-h-0 !rounded-lg !bg-white/75 !px-2 !py-1 !text-[10px] !text-n-slate-11 !outline-none',
  buttonLabel:
    '!h-full !min-h-0 !rounded-lg !bg-white/90 !px-2 !text-right !text-[12px] !font-medium !text-[#128c7e] !outline-none placeholder:!text-[#128c7e]/55',
  buttonLabelCompact:
    '!h-full !min-h-0 !rounded-none !bg-transparent !px-0 !text-right !text-[12px] !font-medium !text-[#128c7e] !outline-none placeholder:!text-[#128c7e]/50',
  headerText:
    '!mt-2 !h-auto !min-h-0 !rounded-xl !bg-white !px-3 !py-2 !text-[11px] !font-medium !text-n-slate-12',
};

const resolvedInputClass = computed(
  () => variantClassMap[props.variant] || variantClassMap.plain
);
</script>

<template>
  <InlineInput
    :model-value="modelValue"
    :placeholder="placeholder"
    :custom-input-class="resolvedInputClass"
    @click.stop
    @update:model-value="emit('update:modelValue', $event)"
  />
</template>
